"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _forms = _interopRequireDefault(require("./forms"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(settings, basePath, path) {
  var pathNumbers = path.match(/\d+/g);
  var sanitizedPath = path.replace(/\d+/g, 'x');
  return _forms["default"].filter(function (form) {
    return form.path === '' || sanitizedPath === form.path || sanitizedPath.startsWith(form.path + '.') || sanitizedPath.startsWith(form.path + '[');
  }).sort(function (a, b) {
    return a.path.length - b.path.length;
  }).map(function (form) {
    var index = 0;
    var breadcrumbPath = form.path.replace(/\[x\]/g, function (_) {
      return "[".concat(pathNumbers[index++], "]");
    });
    var breadcrumbName = form.breadcrumb || 'Unknown';
    if (typeof breadcrumbName === 'function') {
      var partSettings = (0, _get2["default"])(settings, breadcrumbPath, {});
      breadcrumbName = form.breadcrumb(partSettings);
    }
    return {
      path: '/' + breadcrumbPath,
      name: breadcrumbName
    };
  }).filter(function (item) {
    return basePath === '' || item.path.startsWith('/' + basePath);
  });
};